const NewsFilters = () => {

    // Helper function to update the URL with category slug and page number
    const updateUrlParams = (category_slug = '', tag = '', paged) => {
        const url = new URL(window.location);
        if (category_slug) {
            url.searchParams.set('category', category_slug)
        }
        if (tag) {
            url.searchParams.set('tag', tag);
        }
        if (paged) {
            url.searchParams.set('paged', paged);
        }
        window.history.pushState({}, '', url);
    };

    // Helper function to get URL params
    const getUrlParam = (param) => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    };

    // Function to handle fetching filtered news
    const fetchNews = (category_slug = '', tag = '', paged = 1) => {
        document.querySelector('.wp-block-kantarsite-news-list').classList.add('loading');
    
        // Prepare the request body
        const bodyParams = {
            action: 'news_ajax',
            paged: paged,
            security: KANTARSITE_main.ajax_nonce
        };
    
        // Add category_slug to the request body if provided
        if (category_slug) {
            bodyParams.category = category_slug;
        }

        // Add tag to the request body if provided
        if (tag) {
            bodyParams.tag = tag;
        }
    
        // Fetch posts for the selected category slug
        fetch(KANTARSITE_main.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(bodyParams)
        })
        .then(response => response.json())
        .then(data => {
            const newsList = document.querySelector('.wp-block-kantarsite-news-list');
            newsList.classList.remove('loading');
    
            if (data.success) {
                newsList.innerHTML = data.data.posts;
    
                const pagination = document.querySelector('.pagination');
                if (!pagination) return;
    
                pagination.innerHTML = data.data.pagination;
    
                if (!pagination.hasChildNodes()) {
                    pagination.style.display = 'none';
                } else {
                    pagination.style.display = 'flex';
                }
            } else {
                // Handle no posts found
                newsList.innerHTML = '<p>No posts found.</p>';
                console.error(data.data);
            }
        })
        .catch(error => {
            document.querySelector('.wp-block-kantarsite-news-list').classList.remove('loading');
            console.error('Error:', error);
        });
    };

    // Handle category filters
    const FilterCategories = () => {
        const filterLinks = document.querySelectorAll('.news-filters a.article__category');
        const mobileSelect = document.querySelector('.news-filters-mobile');

        if (!filterLinks.length && !mobileSelect) return;

        // Handle click events for filter links
        filterLinks.forEach(link => {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                const category_slug = this.getAttribute('data-category-slug'); // Get slug instead of ID
                fetchNews(category_slug, ''); // Fetch news based on the clicked category slug

                filterLinks.forEach(link => link.classList.remove('active'));
                this.classList.add('active');
                updateUrlParams(category_slug, '', 1);

                // If no category then remove url params
                if (e.target.dataset.category === '') {
                    const url = new URL(window.location);
                    url.search = ''; // Remove all URL parameters
                    window.history.replaceState({}, '', url); 
                }
            });
        });

        // Handle change event for the mobile select field
        if (mobileSelect) {
            mobileSelect.addEventListener('change', function () {
                const selectedOption = this.options[this.selectedIndex];
                const category_slug = selectedOption.getAttribute('data-category-slug'); // Get slug
                fetchNews(category_slug); // Fetch news based on the selected category
                updateUrlParams(category_slug, 1); // Update the URL with slug
            });
        }

        // Set active category based on URL params
        mobileSelect.querySelectorAll('option').forEach(option => {
            if (option.getAttribute('data-category-slug') === getUrlParam('category')) {
                option.selected = true;
            }
        });
    };

    // Handle pagination links
    const FilterPagination = () => {
        document.addEventListener('click', function (e) {
            const target = e.target.closest('.pagination a.page-numbers');
            if (target && target.hasAttribute('data-paged')) {
                e.preventDefault();
                const paged = target.getAttribute('data-paged');
                const activeCategory = document.querySelector('.news-filters a.article__category.active');
                
                // Scroll to top of news list
                const newsList = document.querySelector('#post');
                const newsListOffset = newsList.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({ top: newsListOffset, behavior: 'smooth' });

                if (activeCategory) {
                    const category_slug = activeCategory.getAttribute('data-category-slug');

                    fetchNews(category_slug, '', paged); // Fetch news based on pagination
                    updateUrlParams(category_slug, '', paged); // Update the URL with slug
                } else {
                    // If no category selected then fetch news without category
                    const tag = document.querySelector('.tag-title').textContent;
                    const tagSlug = tag.replace(/\s+/g, '-').toLowerCase();

                    fetchNews('', tagSlug, paged);
                    updateUrlParams('', tagSlug, paged);
                }
            }
        });
    };

    // Fetch the news if URL params exist
    const initFetchFromUrl = () => {
        const category_slug = getUrlParam('category');
        const tag = getUrlParam('tag');
        const paged = getUrlParam('paged') || 1;

        if (category_slug) {
            fetchNews(category_slug, '', paged);
        }

        if (tag) {
            fetchNews('', tag, paged);
        }

        // Highlight the active category
        const activeCategory = document.querySelector(`.news-filters a.article__category[data-category-slug="${category_slug}"]`);
        if (activeCategory) {
            document.querySelectorAll('.news-filters a.article__category').forEach(link => link.classList.remove('active'));
            activeCategory.classList.add('active');
        }
    };

    FilterCategories();
    FilterPagination();
    initFetchFromUrl();
}

export default NewsFilters;